import React, { useContext, useEffect, useState } from 'react';
import Icon from '@ant-design/icons';
import { FloatButton, Form, message } from 'antd';
import constants from '../../Constants/constants';
import { COOKIE, getCookie } from '../../Services/Cookie';
import { fetchApi, fetchDownloadApi } from '../../Services/Api';
import ContactUs from './ContactUs';
import { UserContext } from "../../Context";
import contactIcon from "./../../Assets/contact-us-icon.png"

const ContactUsWithFloater = () => {
  const { showFloater, session } = useContext(UserContext)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [downloadRole, setDownloadRole] = useState('')

  const getRole = () => {
    let roleId = getCookie(COOKIE.Role)
    let role = constants.UserRolesArray.find((it) => it.id === roleId)?.value
    setDownloadRole(role)
  }

  useEffect(() => {
    const { displayName, contactEmail } = session

    form.setFieldsValue({
      name: displayName,
      email: contactEmail,
    })
    getRole()
  }, [openModal, session])

  const handleDownload = () => {
    setLoading(true)
    //types: student, admin, faculty
    fetchDownloadApi(`/download-user-manual/${downloadRole}`, 'get').then((res) => {
      setLoading(false)
      if (res) {
        if (res?.code === 400) {
          message.error(constants.ErrorMessage)
          return
        }
        let url = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf' }));
        let a = document.createElement("a");
        let manualType = constants.UserRolesArray.find((it) => it.value === downloadRole)?.main
        a.download = `${manualType} Manual`;
        a.href = url;
        a.dispatchEvent(new MouseEvent("click"));
        URL.revokeObjectURL(url);
      }
    }).catch(() => {
      message.error(constants.ErrorMessage)
      setLoading(false)
    })
  }

  const handleQuerySubmit = (values) => {
    setLoading(true)
    let isStudent = getCookie(COOKIE.Role) === '0'
    let id = getCookie(COOKIE.UserId)
    
    let formdata = new FormData()
    formdata.append(isStudent ? 'student_id' : 'faculty_id', id)
    formdata.append('name', values?.name)
    formdata.append('email', values?.email)
    formdata.append('body', values?.queries)
    values?.attachments?.fileList?.forEach((it, index) => {
      formdata.append(`attachment[${index}]`, it?.originFileObj)
    })

    fetchApi(`/contact-us`, 'post', formdata).then((res) => {
      setLoading(false)
      if (res?.code === '200') {
        message.success(constants.QuerySentSuccess)
        form.resetFields();
        setOpenModal(false)
        return
      }
      message.error(res?.message)
    }).catch(() => {
      message.error(constants.ErrorMessage)
      setLoading(false)
    })
  }

  const ContactIcon = () => (
    <Icon component={() => <img src={contactIcon} alt="icon" style={{ width: 35, height: 30 }} />} />
  );
  return (
    <>
      {showFloater === 'show' &&
        <FloatButton
          icon={<ContactIcon />}
          type="default"
          className='contact-button'
          tooltip={constants.ContactUs}
          onClick={() => setOpenModal(true)}
        />}
      {openModal &&
        <ContactUs
          openModal={openModal}
          setOpenModal={setOpenModal}
          downloadRole={downloadRole}
          loading={loading}
          form={form}
          handleDownload={handleDownload}
          handleQuerySubmit={handleQuerySubmit}
        />
      }
    </>
  );
}

export default ContactUsWithFloater;